<!--
 * @Description: 合作伙伴-新增
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-04-20 15:29:42
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <baseMessage :disabled="false" :permissionPage="permissionBase" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script setup lang="ts">
import baseMessage from '@/views/yuntuSales/marketing/partnerManage/components/baseMessage.vue'
const permissionBase = {
  save: 'lbu_partner_add_btn'
}
</script>
<script lang="ts">
export default { name: 'DcCosLbuPartnerManageAdd' }
</script>
